import log, { LoggingLevel } from "../../core/log.js";
import Uploader from "../../core/upload/uploader.js";
import { DEFAULT_UPLOAD_TIMEOUT_MS, UploadResult } from "../../core/upload/uploader.js";
const LOG_TAG = "platform.browser.FetchUploader";
class BrowserFetchUploader extends Uploader {
    constructor() {
        super(...arguments);
        this.timeoutMs = DEFAULT_UPLOAD_TIMEOUT_MS;
    }
    async post(url, pingRequest, keepalive = true) {
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), this.timeoutMs);
        const gzipRequest = pingRequest.asCompressedPayload();
        let response;
        try {
            response = await fetch(url.toString(), {
                headers: gzipRequest.headers,
                method: "POST",
                body: gzipRequest.payload,
                keepalive,
                credentials: "omit",
                signal: controller.signal,
                redirect: "error",
            });
        }
        catch (e) {
            if (e instanceof DOMException) {
                log(LOG_TAG, ["Timeout while attempting to upload ping.\n", e], LoggingLevel.Error);
            }
            else if (e instanceof TypeError) {
                if (keepalive) {
                    return this.post(url, gzipRequest, false);
                }
                log(LOG_TAG, ["Network error while attempting to upload ping.\n", e], LoggingLevel.Error);
            }
            else {
                log(LOG_TAG, ["Unknown error while attempting to upload ping.\n", e], LoggingLevel.Error);
            }
            clearTimeout(timeout);
            return new UploadResult(0);
        }
        clearTimeout(timeout);
        return new UploadResult(2, response.status);
    }
    supportsCustomHeaders() {
        return true;
    }
}
export default new BrowserFetchUploader();
